 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		66: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		66: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~orange-len~da707041","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~orange-lens~paint-~0019270f","4":"buybox~promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-mobile","5":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","6":"buybox~promotion-products-lazy~quick-view","7":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","8":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","9":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","10":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","11":"bath-renovation~consumer-card-messaging","12":"buybox~quick-view","13":"compare~overlay","14":"promotion-products-lazy~quick-view","15":"ratings-and-reviews-mobile","16":"StoreLayout","17":"add-to-list-drawer","18":"aisle-bay","19":"augmented-reality","20":"bath-renovation","21":"breadcrumbs","22":"browse-and-search","23":"browse-and-search-mobile","24":"buybox","25":"calculator-pipcalculator","26":"collections","27":"collections-mobile","28":"common","29":"compare","30":"consumer-card-messaging","31":"customer-image-overlay","32":"drawer","33":"emt-generated-content","34":"emt-links","35":"fbr","36":"global-custom-configurator","37":"hammerjs","39":"home","40":"magic-apron","41":"measurement-guide","42":"measurement-guide-overlay-content","43":"media-gallery-filmstrip-mobile","44":"media-gallery-overlay","45":"media-gallery-overlay-mobile","46":"message-types","47":"orange-lens","48":"order-sample","49":"order-sample-drawer","50":"overlay","51":"paint-reorder","52":"paint-reorder-mobile","53":"pep","54":"pep-mobile","55":"product","56":"product-mobile","57":"product-overview","58":"promotion-products-lazy","59":"question","60":"questions-and-answers","61":"quick-view","62":"ratings-and-reviews","63":"ratings-and-reviews-desktop","64":"results","65":"returns-messaging","67":"share-to-email-overlay","68":"share-to-pinterest-overlay","69":"size-guide-overlay","70":"specifications","71":"stylequiz","72":"super-sku","73":"vendor-collection-products","74":"vendor-collections","75":"vendor-collections-mobile","77":"video-player","78":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"92333c3cc21c21e66dd8","1":"7aac3152cba0928a5b12","2":"1f8fa607c282779fc4f9","3":"06b4fdfd4339ccf6a272","4":"a771d76e11929d1d5e67","5":"8179ee9af563685e66fd","6":"c10b4b46190bb4b1b9c2","7":"7ecf684501871be1b0df","8":"66a6b81e6f4307ed0b77","9":"1ae95e6f1deee728370d","10":"f6e19a2f2286fc3b0191","11":"ea01f88e66e187011389","12":"e573e7b01ef050db5aa6","13":"72da619f88aba64f2576","14":"11cda266560d3c1c46cc","15":"6e2ea72f84292542c3a8","16":"16568cb25f732ab9c113","17":"6ea61859443a82ceef49","18":"bcaa209e895c868f2aca","19":"f7282d0c2a1c550b9379","20":"40e7c9c6393cb52c8bd7","21":"90bd2615af3414b10eaf","22":"a7d108c37510f41a57ca","23":"214c7ad567e3e33c4637","24":"f6f64686025c19f34680","25":"9dfd318ada0dc898c42f","26":"3956d083ec3820cfdc13","27":"f5f42accfafd4989c28d","28":"e50e57d27ad10e5cf425","29":"9d1c5717a7d00e271b1b","30":"89f039feabca3a6f64b5","31":"cdab7749a65b27039c94","32":"7e24a91e002ab48a622b","33":"84473a332023b59bcaa2","34":"4062186b02422835fda9","35":"0f84ec75bdf402d40808","36":"258cc06ef42d6a1a6598","37":"a8df4125bdc5402050c7","39":"76d6d0afb0290c7604fd","40":"18270813aa33cae8b073","41":"b325e3e4b38d114f7d1c","42":"4bc6a15acd8cedb944b7","43":"0ce84debc0493ec86bc0","44":"de25ca59a0e8f0e04974","45":"6005cd49ea4844982116","46":"9145f6947519060f82aa","47":"b5cf37aad4dd045f2297","48":"120c94e1d7c13ec7b2da","49":"8d8fa25b362e4b717c70","50":"397f0a3665e86ece408a","51":"e711be5f390f9ff1365e","52":"56e4d2fdbefe3e6a441e","53":"4de87cff9f5446cbb23f","54":"b1b9a149de77be922c82","55":"664681101733eae7bc3a","56":"550e381c9f357cfa98bb","57":"6ff1746d9403d3e3d6c3","58":"ef078a3c91d376d573ea","59":"9a6c0e746c8bba8b06b8","60":"0d6b5b701b6db88c7841","61":"57275284f46f3d239cfe","62":"250b416d4c7fb9a2a5fb","63":"38a100d423a48695e4a6","64":"296214cd540dfa1d3170","65":"1e8109b1d4cc7ac44439","67":"e6f12398077dcdb5917c","68":"bf8e9ba99728e90ef1e9","69":"f6bd675f90072ebf2437","70":"46dcbe728a2aa69ac2df","71":"d83b3d0d97157a266c49","72":"857e16499626f917032f","73":"4c01dc63a24693976caf","74":"812c97b40adcdb4e261a","75":"61a4e476ed1377f03ed1","77":"ff12b56a8b8dec2ef17e","78":"3dc10f4d6d713b29eb45","79":"7d54038b9ba61f8dc0bc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"4":1,"5":1,"7":1,"8":1,"9":1,"10":1,"12":1,"13":1,"14":1,"15":1,"18":1,"20":1,"22":1,"23":1,"24":1,"26":1,"27":1,"29":1,"30":1,"31":1,"32":1,"33":1,"35":1,"36":1,"40":1,"43":1,"44":1,"45":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"60":1,"61":1,"62":1,"69":1,"71":1,"72":1,"73":1,"74":1,"75":1,"78":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~orange-len~da707041","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~orange-lens~paint-~0019270f","4":"buybox~promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-mobile","5":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","6":"buybox~promotion-products-lazy~quick-view","7":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","8":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","9":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","10":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","11":"bath-renovation~consumer-card-messaging","12":"buybox~quick-view","13":"compare~overlay","14":"promotion-products-lazy~quick-view","15":"ratings-and-reviews-mobile","16":"StoreLayout","17":"add-to-list-drawer","18":"aisle-bay","19":"augmented-reality","20":"bath-renovation","21":"breadcrumbs","22":"browse-and-search","23":"browse-and-search-mobile","24":"buybox","25":"calculator-pipcalculator","26":"collections","27":"collections-mobile","28":"common","29":"compare","30":"consumer-card-messaging","31":"customer-image-overlay","32":"drawer","33":"emt-generated-content","34":"emt-links","35":"fbr","36":"global-custom-configurator","37":"hammerjs","39":"home","40":"magic-apron","41":"measurement-guide","42":"measurement-guide-overlay-content","43":"media-gallery-filmstrip-mobile","44":"media-gallery-overlay","45":"media-gallery-overlay-mobile","46":"message-types","47":"orange-lens","48":"order-sample","49":"order-sample-drawer","50":"overlay","51":"paint-reorder","52":"paint-reorder-mobile","53":"pep","54":"pep-mobile","55":"product","56":"product-mobile","57":"product-overview","58":"promotion-products-lazy","59":"question","60":"questions-and-answers","61":"quick-view","62":"ratings-and-reviews","63":"ratings-and-reviews-desktop","64":"results","65":"returns-messaging","67":"share-to-email-overlay","68":"share-to-pinterest-overlay","69":"size-guide-overlay","70":"specifications","71":"stylequiz","72":"super-sku","73":"vendor-collection-products","74":"vendor-collections","75":"vendor-collections-mobile","77":"video-player","78":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"a7a66c20dbc8d080d705","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"daabb420d3c92e26f8a9","5":"89d9163eeb30e835d559","6":"31d6cfe0d16ae931b73c","7":"0ef658ad0521bc70e648","8":"3f2ab2ee90ec8805c3d8","9":"50d430c72ccc3cf96a34","10":"65f1d7aedc445dc5836f","11":"31d6cfe0d16ae931b73c","12":"95a5994acce6e02a6b07","13":"f148c51c805227319d9f","14":"2a09750166a70e474555","15":"f38aaee08af9e508beb8","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"d94b956aa532c1a50c65","19":"31d6cfe0d16ae931b73c","20":"66bba79b70e3924b990e","21":"31d6cfe0d16ae931b73c","22":"7847988ff5d69961da4c","23":"0fb0dcf80db9aca96594","24":"89a098ef4880dbc9f6d2","25":"31d6cfe0d16ae931b73c","26":"f8f627fa0d80cff7ceec","27":"a022849ec3d1cb137773","28":"31d6cfe0d16ae931b73c","29":"362531098d01fcd57ec8","30":"c07ce9ab259c3f695942","31":"32b2ceba1e4cfc936c08","32":"fc73174b407ad863c497","33":"b49004ddac99adec2224","34":"31d6cfe0d16ae931b73c","35":"88e24c7aafcf93ae6cc6","36":"1a5562a08d12f7682989","37":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"ceebf150d8a696023a14","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"e07956ac4ef9facbea2e","44":"7137017d1065c39f449e","45":"ae09f56f4988cacb1db2","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"59a5cb0e4cb5fbeab2c5","51":"33094dc370519ea0a2ec","52":"93f297ca2f103e85850d","53":"2447d30e738d4f3b425a","54":"76ba5d6b608e53902350","55":"05c7e0101a1c6d73cbf2","56":"4d316e326181d19a1049","57":"be155bb5d11dacdc4bb8","58":"c7e4a3cb02089bb4d052","59":"31d6cfe0d16ae931b73c","60":"d70c859b20e57c1599c5","61":"3fb67ef60d9f4cf19fb8","62":"9d02d79dc9b8f52f7762","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"453dfc2640779a848cc6","70":"31d6cfe0d16ae931b73c","71":"fdbbfce8ec610b101975","72":"922dbc8ed510a58afe20","73":"e518e335254638969e62","74":"4cb3f71a358bf55dfe6c","75":"9ab529081f3b3b25b37b","77":"31d6cfe0d16ae931b73c","78":"60f7c79bb330e8e8c008","79":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
